(function () {
  var observedCartRoots = new WeakSet();

  function formatCartCountText(text) {
    var count = parseInt(String(text || '').trim(), 10);
    if (Number.isNaN(count)) return text;
    return count < 10 ? '0' + count : String(count);
  }

  function syncMegaMenuCartCounts() {
    document
      .querySelectorAll('.spclst-mega-mobile-drawer .mobilecartcount, .spclst-megamenu-navbar .mobilecartcount')
      .forEach(function (countEl) {
        var formattedCount = formatCartCountText(countEl.textContent);
        if (countEl.textContent !== formattedCount) {
          countEl.textContent = formattedCount;
        }
      });
  }

  function initMegaMenuCartCounts() {
    syncMegaMenuCartCounts();

    if (!window.MutationObserver) return;
    // Product animations, chat and review updates must not rescan the cart header.
    document.querySelectorAll('.spclst-mega-mobile-drawer, .spclst-megamenu-navbar').forEach(function (root) {
      if (observedCartRoots.has(root)) return;
      observedCartRoots.add(root);
      var observer = new MutationObserver(syncMegaMenuCartCounts);
      observer.observe(root, { childList: true, characterData: true, subtree: true });
      var section = root.closest('.shopify-section');
      if (section) section.addEventListener('shopify:section:unload', function () {
        observer.disconnect();
        observedCartRoots.delete(root);
      }, { once: true });
    });
  }

  function initMegaMenu(root) {
    if (!root || root.getAttribute('data-spclst-megamenu-initialized') === 'true') return;
    root.setAttribute('data-spclst-megamenu-initialized', 'true');
    initMegaMenuCartCounts();
  }

  function initAllMegaMenus() {
    document.querySelectorAll('.spclst-megamenu-navbar').forEach(initMegaMenu);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllMegaMenus);
  } else {
    initAllMegaMenus();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event || !event.target) return;
    event.target.querySelectorAll('.spclst-megamenu-navbar').forEach(initMegaMenu);
  });
})();
